export default class ResponseParser {
    getFilenameFromHeaders(headers) {
        const headerLine = headers['content-disposition'];
        const startFileNameIndex = headerLine.indexOf('"') + 1;
        const endFileNameIndex = headerLine.lastIndexOf('"');
        return headerLine.substring(startFileNameIndex, endFileNameIndex);
    }
}
